import fetch from '../utils/fetch';

export const getArticleById = async (shareID) => {
	return fetch('GET', `/shares/${shareID}`);
};
